import { LIBRARY_SCROLL_POSITION_KEY } from '../constant';

// validRoutes defines the path patterns for which we want to preserve the scroll position
const validRoutes = [
  '/library',
  '/dashboard/library',
  '/deck',
  '/assessment',
  '/pages',
  '/event',
  '/embed/library',
  '/embed/deck',
  '/embed/assessment',
  '/duel',
  '/highscore',
  '/practice',
];

export function resetLibraryScrollPosition(pathname?: string) {
  const isValidRoute = validRoutes.some(route => pathname?.startsWith(route));

  if (!isValidRoute) {
    sessionStorage.removeItem(LIBRARY_SCROLL_POSITION_KEY);
  }
}
